// IMPORTANT: Make sure this is in sync with functions/src/index.ts
export enum STRIPE_PROMOTION_VALIDATION_STATUS {
    valid = 'valid',
    invalid = 'invalid',
    expired = 'expired',
}
